import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text, Icon } from 'mintel-react-ui';
import { h3Size } from 'mintel-tokens';

import facebookLogo from '/assets/images/facebook-logo.png';
import instagramLogo from '/assets/images/instagram-logo.png';
import linkedinLogo from '/assets/images/linkedin-logo.png';
import pinterestLogo from '/assets/images/pinterest-logo.png';
import tiktokLogo from '/assets/images/tiktok-logo.png';
import twitterLogo from '/assets/images/twitter-logo.png';
import youtubeLogo from '/assets/images/youtube-logo.png';
import { SocialMediaPlatformType } from '/types';
import { BlockBackgroundContext } from '/utils/contexts';
import useTranslate, { i18n } from '/utils/translations';

import styles from './BlockedSocialPost.scss';

export const logoImages: { [key in SocialMediaPlatformType]: unknown } = {
  facebook: facebookLogo,
  instagram: instagramLogo,
  linkedin: linkedinLogo,
  pinterest: pinterestLogo,
  tiktok: tiktokLogo,
  twitter: twitterLogo,
  youtube: youtubeLogo,
};

const BlockedSocialPost: VFC<{
  provider: SocialMediaPlatformType;
  link: string;
}> = ({ provider, link }) => {
  const t = useTranslate();
  const { darkBg } = useContext(BlockBackgroundContext);
  const mainMessage = t('The following post is not available');
  const openLink = (): void => {
    window.open(link, '_blank');
  };

  return (
    <div
      className={classNames(styles.blockedPost, { [styles.dark]: darkBg })}
      role="link"
      aria-label={mainMessage}
      tabIndex={0}
      onClick={openLink}
      onKeyDown={(e): void => {
        if (e.key === 'Enter') {
          openLink();
        }
      }}
    >
      <div className={styles.header}>
        <div className={styles.profile}>
          <div className={styles.pic} />
          <div className={styles.titles}>
            <div className={styles.top} />
            <div className={styles.bottom} />
          </div>
        </div>
        <div
          className={styles.logo}
          style={{ backgroundImage: `url(${logoImages[provider]})` }}
        />
      </div>
      <div className={styles.body}>
        <Text.Heading3>
          <Icon
            size={h3Size}
            name="warning"
            color="black"
            className={styles.warningIcon}
          />
          {mainMessage}
        </Text.Heading3>
        {i18n.language !== 'th' && (
          <span data-testid="submessage">
            <Text.Body>
              {t(
                'It may have been removed, blocked or the privacy settings of the post have changed.',
              )}
            </Text.Body>
          </span>
        )}
      </div>
    </div>
  );
};

export default BlockedSocialPost;
